import { RrsCategory } from "server/models"
import { TableGroupedIds } from "client/components"
import { RrsCategoryCustomVariable } from "client/utils"

export interface RrsCategoryProps {
    categoryId: number
}

export interface RrsCategoryList { [categoryId: number]: RrsCategory }
export interface RrsCategoryFilters {
    search?: string
}

export type RrsCategoryChildParent = { [childId: number]: number } // { [childId]: parentId }
export type RrsCategoryValidation = { [key in keyof RrsCategory]?: string }
export type RrsCategoryCustomVariableValidation = {
    [index: number]: { [key in keyof RrsCategoryCustomVariable]?: string }
}

export interface RrsCategoryState {
    baseRoute: string

    categoryList: RrsCategoryList
    categoryIds: readonly TableGroupedIds[]
    categoryChildParent: RrsCategoryChildParent
    categoryEdit: RrsCategory

    filters: RrsCategoryFilters

    // status change
    statusActive: number

    // confirm delete
    active: RrsCategory
    showConfirmDelete: boolean

    reloadList: boolean
    reloadEdit: boolean
}

export const RRS_CATEGORY_BASE_ROUTE = "RRS_CATEGORY_BASE_ROUTE"

export const RRS_CATEGORY_LIST = "RRS_CATEGORY_LIST"
export const RRS_CATEGORY_IDS = "RRS_CATEGORY_IDS"
export const RRS_CATEGORY_CHILD_PARENT = "RRS_CATEGORY_CHILD_PARENT"
export const RRS_CATEGORY_EDIT = "RRS_CATEGORY_EDIT"

export const RRS_CATEGORY_FILTERS = "RRS_CATEGORY_FILTERS"

// status change
export const RRS_CATEGORY_STATUS_ACTIVE = "RRS_CATEGORY_STATUS_ACTIVE"

// confirm delete
export const RRS_CATEGORY_ACTIVE = "RRS_CATEGORY_ACTIVE"
export const RRS_CATEGORY_SHOW_CONFIRM_DELETE = "RRS_CATEGORY_SHOW_CONFIRM_DELETE"

export const RRS_CATEGORY_RELOAD_LIST = "RRS_CATEGORY_RELOAD_LIST"
export const RRS_CATEGORY_RELOAD_EDIT = "RRS_CATEGORY_RELOAD_EDIT"
